import { render, staticRenderFns } from "./workFlow.vue?vue&type=template&id=b00cc0c4&scoped=true&"
import script from "./workFlow.vue?vue&type=script&lang=js&"
export * from "./workFlow.vue?vue&type=script&lang=js&"
import style0 from "./workFlow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./workFlow.vue?vue&type=style&index=1&id=b00cc0c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00cc0c4",
  null
  
)

export default component.exports